/** Orchestrator + context + AI can exceed the default httpClient timeout (15s). */
export const LONG_ORCHESTRATOR_REQUEST_MS = 90_000;
